<div class="list-wrapper">
  <kgrid
    *ngIf="WarehouseGoodsColumns && WarehouseGoodsColumns.length > 0"
    [apiName]="apiName"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    [isModal]="false"
    [isAdd]="false"
    [isEdit]="false"
    [isDelete]="false"
    defaultSortKey="WarehouseCode,GoodsCode"
    [columns]="WarehouseGoodsColumns"
    reportName="WarehouseGoodsReport"
    pathPreFix="INV">
  </kgrid>
</div>
